/* eslint-disable jsx-quotes */
/* eslint-disable multiline-ternary */
/* eslint-disable indent */
/* eslint-disable max-len */
import { Form, Formik, FormikContextType } from "formik";
import { useRef, useState } from "react";
import {
  FieldControllerTypes,
  FieldTypes,
  IFormController,
} from "../../form_v2/types";
import FormLayout from "../../layout/Form/FormLayout";
import { VerticalStepper } from "../../Stepper";
import FormActionButtonLayout from "../../layout/Form/FormActionButtonLayout";
import {
  Button,
  Box,
  FormHelperText,
  Typography,
  Paper,
  IconButton,
} from "@mui/material";
import {
  findGeolocationFromAddress,
  isSubmitEnabled,
} from "../../../lib/helperFuncs";
import { IApplicationFormSteps } from "./Types";
import { formInStepperBuilder, renderErrors } from "../../form_v2/helpers";
import HomeIcon from "@mui/icons-material/Home";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactsIcon from "@mui/icons-material/Contacts";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  acceptedDoc,
  acceptedImage,
  acceptedVideo,
  ApiUsability,
  ILevel3,
} from "../../../lib/generalTypes";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DialogAction from "../../Dialog/DialogAction";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPoint } from "../../Maps/types";
import { validationSchema } from "../../../lib/static/locations/validationSchema";
import HttpService from "../../../services/HttpService";
import { useSnackbar } from "notistack";
import UserService from "../../../services/UserService";
import { IntExt, Permissions } from "../../../lib/permissions";
import i18n from "../../../i18n";
import { useApiState } from "../../../hooks/useApiState";
import RateReviewIcon from "@mui/icons-material/RateReview";
import GMapsWithDraggableCenter from "../../Maps/GMapsWithDraggableCenter";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
export const showOnlySelectedOptions = (selected: any, options: ILevel3[]) => {
  const selectedOptions = selected.map((selectedItem: any) => {
    return options?.filter(
      (option: ILevel3) => option.level1Id == selectedItem.value
    );
  });

  return selectedOptions?.flat() || [];
};

const ApplicationFormSteps = ({
  initialValues,
  level1Options,
  level2Options,
  level3Options,
  regions,
  onSubmit,
  isLoading,
  edit = false,
  preinserted = false,
}: IApplicationFormSteps) => {
  const { apiEnabled, loadingApi } = useApiState(
    ApiUsability.Google_Maps,
    true
  );
  const { apiEnabled: geoLocationApi, loadingApi: geoLocationLoading } =
    useApiState(ApiUsability.Geolocation);
  const { apiEnabled: visionApi, loadingApi: visionLoading } = useApiState(
    ApiUsability.Google_Vision
  );

  const formRef = useRef<FormikContextType<any>>(null);
  const [geolocation, setGeolocation] = useState<MapPoint>({
    lat: initialValues?.lat ? Number(initialValues?.lat) : null,
    lng: initialValues?.lon ? Number(initialValues?.lon) : null,
  });
  const [geolocationError, setGeolocationError] = useState<string>("");
  const [selectedThematiki, setSelectedThematiki] = useState(
    initialValues?.category_lvl1 || []
  );
  const [openSubmit, setOpenSubmit] = useState<boolean>(false);
  const [openCancel, setOpenCancel] = useState<boolean>(false);
  const [visionLabels, setVisionLabels] = useState<string[]>([]);
  const [locationDescription, setLocationDescription] = useState<any>(initialValues?.info_property || "");
  const [locationDescriptionEn, setLocationDescriptionEn] = useState<any>(initialValues?.info_property_en || "");
  const [isLoadingChat, setIsLoadingChat] = useState<boolean>(false);
  const [isLoadingChatEn, setIsLoadingChatEn] = useState<boolean>(false);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const is_external = UserService.hasRole([IntExt.External]);

  const radioOptions = () => {
    return [
      { key: t("ΝΑΙ"), value: true },
      { key: t("ΟΧΙ"), value: false },
    ];
  };

  const markerRadioOptions = () => {
    return [
      { key: t("Ορατό στο κοινό"), value: "visible" },
      { key: t("Ενδεικτικό"), value: "sample" },
      { key: t("Μη ορατό στο κοινό"), value: "hidden" },
    ];
  };

  const uploadImageToDetectLabels = async (file: any) => {
    if (file.length === 0) {
      setVisionLabels([]);
    } else {
      const formData = new FormData();
      formData.append("file", file[0]);
      try {
        enqueueSnackbar(
          t("Εντοπισμός labels για τις εικόνες που έχετε επιλέξει..."),
          { variant: "info", autoHideDuration: 2000 }
        );
        const response = await HttpService.getAxiosClient().post(
          `${process.env.REACT_APP_BACKEND_URL}/locations/url`,
          formData
        );
        setVisionLabels(response.data.map((option: any) => option.value));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const step1Form = [
    {
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: is_external ? t("Τίτλος Ιδιοκτησίας") : t("Τίτλος Τοποθεσίας"),
      name: "title_property",
      required: true,
      info: is_external ? true : false,
      tooltip: t("Έτσι θα εμφανίζεται ο τίτλος ιδιοκτησίας στο κοινό"),
    },
    [
      {
        control: FieldControllerTypes.autocomplete,
        type: FieldTypes.autocomplete,
        label: t("Θεματική Ενότητα"),
        name: "category_lvl1",
        options: level1Options,
        required: true,
        row: true,
        customLabel: true,
        selectedItem: (selectedValues: ILevel3[]) =>
          setSelectedThematiki(selectedValues),
        isLoading: isLoading,
      },
      {
        control: FieldControllerTypes.autocomplete,
        type: FieldTypes.autocomplete,
        label: t("Κατηγορία Τοποθεσίας"),
        name: "category_loc",
        disabled: !edit && selectedThematiki.length === 0,
        options: level2Options.filter((item) => {
          return selectedThematiki.some(
            (selectedItem: any) => selectedItem.key === item.parent
          );
        }),
        row: true,
        groupByElement: "parent",
        customLabel: true,
        isLoading: isLoading,
      },
      {
        control: FieldControllerTypes.autocomplete,
        type: FieldTypes.autocomplete,
        label: t("Έπιπλέον Κατηγορία"),
        name: "category_lvl3",
        hidden:
          showOnlySelectedOptions(selectedThematiki, level3Options).length > 0
            ? false
            : true,
        options: showOnlySelectedOptions(selectedThematiki, level3Options),
        row: true,
        groupByElement: "parent",
        customLabel: true,
        isLoading: isLoading,
      },
    ],
    ...(i18n.language !== "en"
      ? [
          {
            control: FieldControllerTypes.textarea,
            type: FieldTypes.text,
            name: "licensing",
            label: t("Πληροφορίες Αδειοδότησης"),
            placeholder: is_external
              ? t("Εισάγετε πληροφορίες αδειοδότησης")
              : null,
          },
        ]
      : []),
    ...(i18n.language !== "el"
      ? [
          {
            control: FieldControllerTypes.textarea,
            type: FieldTypes.text,
            name: "licensing_en",
            label: t("Πληροφορίες Αδειοδότησης"),
            placeholder: is_external
              ? t("Εισάγετε πληροφορίες αδειοδότησης στα Αγγλικά")
              : null,
          },
        ]
      : []),
    [
      {
        control: FieldControllerTypes.radio,
        type: FieldTypes.radio,
        name: "amea",
        label: t("Πρόσβαση σε άτομα με αναπηρία (ΑμεΑ)"),
        options: radioOptions(),
        row: true,
      },
      {
        control: FieldControllerTypes.radio,
        type: FieldTypes.radio,
        name: "heavy_vehicles",
        label: t("Πρόσβαση σε βαρέα οχήματα"),
        options: radioOptions(),
        row: true,
      },
    ],
    ...(i18n.language !== "en"
      ? [
          {
            control: FieldControllerTypes.textarea,
            type: FieldTypes.text,
            name: "limitations",
            label: t("Περιορισμοί"),
            placeholder: t(
              "Εισάγετε τυχόν περιορισμούς που θα πρέπει να γνωρίζει η εταιρεία παραγωγής."
            ),
          },
        ]
      : []),
    {
      control: FieldControllerTypes.textarea,
      type: FieldTypes.text,
      name: "limitations_en",
      label: t("Περιορισμοί στα Αγγλικά"),
      placeholder: t(
        "Εισάγετε τυχόν περιορισμούς που θα πρέπει να γνωρίζει η εταιρεία παραγωγής στα Αγγλικά."
      ),
    },
  ];

  const step2Forms: (IFormController[] | JSX.Element)[] = [
    [
      {
        control: FieldControllerTypes.radio,
        type: FieldTypes.radio,
        label: t("Θέλω το στίγμα της τοποθεσίας στον χάρτη να είναι:"),
        name: "marker",
        required: true,
        options: markerRadioOptions(),
      },
    ],
    [
      {
        control: FieldControllerTypes.autoselect,
        label: t("Περιφέρειες/Δήμοι"),
        name: "region",
        options: regions,
        customLabel: true,
        required: true,
        disabled: !edit
          ? UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationCreateMy_org,
            ]) &&
            !UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationCreateAll,
            ])
          : UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationModificationRequestCreateMy_org,
            ]) &&
            !UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationModificationRequestCreateAll,
            ]),
      },
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.number,
        label: t("ΤΚ"),
        name: "addressPostalCode",
        required: true,
      },
    ],
    [
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.text,
        label: t("Οδός"),
        name: "addressName",
      },
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.text,
        label: t("Αριθμός"),
        name: "addressNumber",
      },
    ],
    (apiEnabled && !loadingApi) || (geoLocationApi && !geoLocationLoading) ? (
      <Box my={2} key="map-form">
        {geoLocationApi && !geoLocationLoading ? (
          <Box 
            my={2} 
            display="flex"
            justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={async () => {
                try {
                  formRef?.current?.setFieldTouched("location", true);
                  const foundLocation = await findGeolocationFromAddress(
                    `
            ${formRef?.current?.values.addressName || ""} 
            ${formRef?.current?.values.addressNumber || ""} 
            ${formRef?.current?.values.addressPostalCode || ""}`
                  );
                  // increase geolocation api counter usability
                  await HttpService.getAxiosClient().patch(
                    `${process.env.REACT_APP_BACKEND_URL}/crm/api/${ApiUsability.Geolocation}`
                  );
                  setGeolocation(foundLocation);
                  if (foundLocation?.lat == 0 && foundLocation?.lng == 0) {
                    setGeolocationError("Δεν βρέθηκε τοποθεσία");
                  }
                  formRef?.current?.registerField("location", {
                    validate: () =>
                      foundLocation?.lat == 0 && foundLocation?.lng == 0
                        ? "Δεν βρέθηκε τοποθεσία"
                        : "",
                  });
                  if (foundLocation?.lat !== 0 && foundLocation?.lng !== 0) {
                    formRef?.current?.setFieldError("location", undefined);
                    setGeolocationError("");
                  }

                  formRef?.current?.setFieldValue("location", foundLocation);
                } catch (error) {
                  console.error(error);
                }
              }}
            >
              {t("Αναζήτηση Τοποθεσίας")}
            </Button>
          </Box>
        ) : null}
        {apiEnabled && !loadingApi ? (
          <Paper
            variant="outlined"
            sx={{
              height: "fit-content",
              boxShadow: 0,
              backgroundColor: "inherit",
            }}
          >
            <GMapsWithDraggableCenter
              height="450px"
              zoom={14}
              changingCenter={setGeolocation}
              location={
                geolocation.lat && geolocation.lng
                  ? {
                      lat: Number(geolocation.lat),
                      lng: Number(geolocation.lng),
                    }
                  : undefined
              }
            />
          </Paper>
        ) : null}
        {geolocationError && (
          <FormHelperText error>
            <Typography
              variant="body1"
              sx={{
                marginTop: "16px",
                fontWeight: "bolder",
              }}
            >
              {geolocationError}
            </Typography>
          </FormHelperText>
        )}
      </Box>
    ) : (
      []
    ),
  ];

  const step3Forms = [
    {
      control: FieldControllerTypes.file,
      type: FieldTypes.file,
      label: t("Προσθήκη Φωτογραφίας Εξωφύλλου"),
      name: "fileThumbnail",
      required: true,
      accepts: [...acceptedImage],
      ...(visionApi &&
        !visionLoading && { onFileSelect: uploadImageToDetectLabels }),
    },
    {
      control: FieldControllerTypes.file,
      type: FieldTypes.file,
      label: t("Προσθήκη Φωτογραφιών/Βίντεο"),
      name: "otherMedia",
      multiple: true,
      ...(!preinserted && { nofiles: 10 }),
      accepts: [...acceptedImage, ...acceptedVideo],
    },
    {
      control: FieldControllerTypes.chips,
      type: FieldTypes.autocomplete,
      label: t("Λέξεις - Κλειδιά"),
      name: "keywords",
      description: t(
        "Εισάγετε λέξεις κλειδιά για την τοποθεσία μόνο στα Αγγλικά, ώστε η ιδιοκτησία σας να προωθείται καλύτερα στον οδηγό τοποθεσιών του ΕΚΟΜΕ"
      ),
      placeholder: t("Εισάγετε λέξεις εδώ και πατήστε `Enter`."),
      options: visionApi && !visionLoading ? visionLabels : [],
    },
    ...(i18n.language !== "en" || !is_external
      ? [
          {
            control: FieldControllerTypes.chips,
            type: FieldTypes.autocomplete,
            label: t("Λέξεις - Κλειδιά στα Ελληνικά"),
            name: "keywords_gr",
            description: t(
              "Εισάγετε λέξεις κλειδιά για την τοποθεσία στα Ελληνικά, ώστε η ιδιοκτησία σας να προωθείται καλύτερα στον οδηγό τοποθεσιών του ΕΚΟΜΕ"
            ),
            placeholder: t("Εισάγετε λέξεις εδώ και πατήστε `Enter`."),
            options: [],
          },
        ]
      : []),
  ];

  const step4Forms = [
    {
      control: FieldControllerTypes.textarea,
      type: FieldTypes.text,
      name: "info_property_en",
      disabled: isLoadingChatEn,
      label: (
        <Box display="flex" justifyContent={"space-between"}>
          {is_external
            ? t("Πληροφορίες Ιδιοκτησίας στα Αγγλικά *")
            : t("Πληροφορίες Τοποθεσίας στα Αγγλικά *")}
          <IconButton
            size="small"
            sx={{
              bgcolor: "rgb(22, 34, 170)",
              color: "white",
              "&:hover": { bgcolor: "rgb(22, 34, 150)" },
              mt: 0.5,
            }}
            onClick={async () => {
              try {
                setIsLoadingChatEn(true);
                const descr_en = await HttpService.getAxiosClient().post(
                  `${process.env.REACT_APP_BACKEND_URL}/locations/chat`,
                  {
                    title_property: formRef?.current?.values.title_property,
                    keywords: formRef?.current?.values.keywords,
                  }
                );
                formRef?.current?.setFieldValue(
                  "info_property_en",
                  descr_en.data.description
                );
                setLocationDescriptionEn(descr_en.data.description);
              } catch (error) {
                console.error(error);
              } finally {
                setIsLoadingChatEn(false);
              }
            }}
          >
            {!isLoadingChatEn ? (
              <RateReviewIcon />
            ) : (
              <span
                style={{
                  display: "inline-block",
                  animation: isLoadingChatEn
                    ? "spin 2s linear infinite"
                    : "none",
                  transform: isLoadingChatEn ? "rotate(360deg)" : "none",
                }}
              >
                <HourglassTopIcon />
                <style>
                  {` @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }}`}
                </style>
              </span>
            )}
          </IconButton>
        </Box>
      ),
      placeholder: is_external
        ? t(
            "Εισάγετε πληροφορίες για την ιδιοκτησία σας, την τοποθεσία που βρίσκεται, τα πλεονεκτήματα και τις δυνατότητες που παρέχει."
          )
        : null,
      // required: i18n.language === "en" && is_external ? true : false,
      value: locationDescriptionEn,
      onChange: (e: any) => {
        setLocationDescriptionEn(e.target.value);
        formRef?.current?.setFieldValue("info_property_en", e.target.value);
      },
    },
    ...(i18n.language !== "en"
      ? [
          {
            control: FieldControllerTypes.textarea,
            type: FieldTypes.text,
            name: "info_property",
            disabled: isLoadingChat,
            label: (
              <Box display="flex" justifyContent={"space-between"}>
                {is_external
                  ? t("Πληροφορίες Ιδιοκτησίας *")
                  : t("Πληροφορίες Τοποθεσίας *")}
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: "rgb(22, 34, 170)",
                    color: "white",
                    "&:hover": { bgcolor: "rgb(22, 34, 150)" },
                  }}
                  onClick={async () => {
                    try {
                      setIsLoadingChat(true);
                      const descr_gr = await HttpService.getAxiosClient().post(
                        `${process.env.REACT_APP_BACKEND_URL}/locations/chat`,
                        {
                          title_property:
                            formRef?.current?.values.title_property,
                          keywords_gr: formRef?.current?.values.keywords_gr,
                        }
                      );
                      formRef?.current?.setFieldValue(
                        "info_property",
                        descr_gr.data.description
                      );
                      setLocationDescription(descr_gr.data.description);
                    } catch (error) {
                      console.error(error);
                    } finally {
                      setIsLoadingChat(false);
                    }
                  }}
                >
                  {!isLoadingChat ? (
                    <RateReviewIcon />
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        animation: isLoadingChat
                          ? "spin 2s linear infinite"
                          : "none",
                        transform: isLoadingChat ? "rotate(360deg)" : "none",
                      }}
                    >
                      <HourglassTopIcon />
                      <style>
                        {` @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }}`}
                      </style>
                    </span>
                  )}
                </IconButton>
              </Box>
            ),
            placeholder: is_external
              ? t(
                  "Εισάγετε πληροφορίες για την ιδιοκτησία σας, την τοποθεσία που βρίσκεται, τα πλεονεκτήματα και τις δυνατότητες που παρέχει."
                )
              : null,
            value: locationDescription,
            onChange: (e: any) => {
              setLocationDescription(e.target.value);
              formRef?.current?.setFieldValue("info_property", e.target.value);
            },
          },
        ]
      : []),
  ];

  const step5Forms: IFormController[][] = [
    ...(is_external
      ? [
          [
            {
              control: FieldControllerTypes.input,
              type: FieldTypes.text,
              label: t("Όνομα"),
              name: "name",
              required: true,
            },
            {
              control: FieldControllerTypes.input,
              type: FieldTypes.text,
              label: t("Επώνυμο"),
              name: "surname",
              required: true,
            },
          ],
        ]
      : []),
    [
      {
        control: FieldControllerTypes.telInput,
        type: FieldTypes.text,
        label: t("Τηλέφωνο"),
        name: "phone",
        required: true,
      },
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.text,
        label: t("Email"),
        name: "email",
        required: true,
      },
    ],
    [
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.text,
        label: "Website",
        name: "website",
        placeholder: "http://www.example.com",
      },
    ],
  ];

  const step6Forms = [
    {
      control: FieldControllerTypes.file,
      type: FieldTypes.file,
      label: t("Προσθήκη Εγγράφων"),
      name: "attachments",
      multiple: true,
      accepts: [...acceptedDoc],
    },
  ];

  const step1 = {
    label: t("Βασικές Πληροφορίες"),
    icon: <HomeIcon />,
    content: step1Form,
  };
  const step2 = {
    label: t("Διεύθυνση"),
    icon: <LocationOnIcon />,
    content: step2Forms,
  };
  const step3 = {
    label: t("Φωτογραφίες / Βίντεο"),
    icon: <PhotoCameraIcon />,
    content: step3Forms,
  };
  const step4 = {
    label: t("Περιγραφή Τοποθεσίας"),
    icon: <DescriptionIcon />,
    content: step4Forms,
    tooltip: t(
      "Μπορείτε να προβείτε σε αυτόματη συμπλήρωση περιγραφής τοποθεσίας πατώντας το κουμπί.Για την αυτόματη δημιουργία κειμένου λαμβάνται υπόψην ο Τίτλος της τοποθεσίας και οι λέξεις κλειδιά που έχετε δώσει."
    ),
  };
  const step5 = {
    label: t("Στοιχεία υπεύθυνου επικοινωνίας"),
    icon: <ContactsIcon />,
    content: step5Forms,
  };
  const step6 = {
    label: t("Άλλα Επισυναπτόμενα Έγγραφα"),
    icon: <PictureAsPdfIcon />,
    content: step6Forms,
  };

  const wholeForm = [
    { ...step1 },
    { ...step2 },
    { ...step3 },
    { ...step4 },
    { ...step5 },
    { ...step6 },
  ];

  const errorsArray = [
    ...[
      {
        name: is_external ? t("Τίτλος Ιδιοκτησίας") : t("Τίτλος Τοποθεσίας"),
        value: "",
        refValue: "title_property",
      },
      {
        name: t("Θεματική Ενότητα"),
        value: "",
        refValue: "category_lvl1",
      },
      {
        name: is_external
          ? t("Κατηγορία Ιδιοκτησίας")
          : t("Κατηγορία Tοποθεσίας"),
        value: "",
        refValue: "category_loc",
      },
      ...(i18n.language !== "en"
        ? [
            {
              name: "Πληροφορίες Ιδιοκτησίας",
              value: "",
              refValue: "info_property",
            },
          ]
        : []),
      {
        name: is_external
          ? t("Πληροφορίες Ιδιοκτησίας στα Αγγλικά")
          : t("Πληροφορίες Τοποθεσίας στα Αγγλικά"),
        value: "",
        refValue: "info_property_en",
      },
      ...(i18n.language !== "en"
        ? [
            {
              name: t("Πληροφορίες Αδειοδότησης"),
              value: "",
              refValue: "licensing",
            },
          ]
        : []),
      ...(i18n.language !== "el"
        ? [
            {
              name: t("Πληροφορίες Αδειοδότησης"),
              value: "",
              refValue: "licensing_en",
            },
          ]
        : []),
      {
        name: t("Πρόσβαση σε άτομα με ειδικές ανάγκες"),
        value: "",
        refValue: "amea",
      },
      {
        name: t("Πρόσβαση σε βαρέα οχήματα"),
        value: "",
        refValue: "heavy_vehicles",
      },
      ...(i18n.language !== "en"
        ? [
            {
              name: t("Περιορισμοί"),
              value: "",
              refValue: "limitations",
            },
          ]
        : []),
      {
        name: t("Περιορισμοί στα Αγγλικά"),
        value: "",
        refValue: "limitations_en",
      },
      {
        name: t("Λέξεις - Κλειδιά"),
        value: "",
        refValue: "tags",
      },
      ...(i18n.language !== "en"
        ? [
            {
              name: t("Λέξεις - Κλειδιά στα Ελληνικά"),
              value: "",
              refValue: "tags_gr",
            },
          ]
        : []),
    ],
    ...[
      {
        name: t("Εμφάνιση στίγματος στον χάρτη"),
        value: "",
        refValue: "marker",
      },
      {
        name: t("Περιφέρειες / Δήμοι"),
        value: "",
        refValue: "region",
      },
      {
        name: t("ΤΚ"),
        value: "",
        refValue: "addressPostalCode",
      },
      {
        name: t("Οδός"),
        value: "",
        refValue: "addressName",
      },
      {
        name: t("Αριθμός"),
        value: "",
        refValue: "addressNumber",
      },
    ],
    ...[
      ...(is_external
        ? [
            {
              name: t("Όνομα"),
              value: initialValues?.name || "-",
              refValue: "name",
            },
          ]
        : []),
      ...(is_external
        ? [
            {
              name: t("Επώνυμο"),
              value: "",
              refValue: "surname",
            },
          ]
        : []),
      {
        name: t("Τηλέφωνο"),
        value: "",
        refValue: "phone",
      },
      {
        name: "Email",
        value: initialValues?.email || "-",
        refValue: "email",
      },
      {
        name: "Website",
        value: initialValues?.website || "-",
        refValue: "website",
      },
    ],
    ...[
      {
        name: "Φωτογραφία Εξωφύλλου",
        value: "",
        refValue: "fileThumbnail",
      },
      {
        name: "Φωτογραφίες/Βίντεο",
        value: "",
        refValue: "otherMedia",
      },
      {
        name: "Επισυναπτόμενα Έγγραφα",
        value: "",
        refValue: "attachments",
      },
    ],
    ...[
      {
        name: "Επιβεβαίωση Διεύθυνσης",
        value: String(initialValues?.lat) || "",
        refValue: "location",
      },
    ],
  ];

  return (
    <>
      <Formik
        onSubmit={() => undefined}
        initialValues={initialValues}
        validationSchema={validationSchema(preinserted)}
        innerRef={formRef}
        validateOnBlur={false}
        validateOnMount
      >
        {(formik) => (
          <>
            <Form>
              <FormLayout>
                <VerticalStepper activeStep={1}>
                  {formInStepperBuilder(wholeForm, formik, !edit)}
                </VerticalStepper>
              </FormLayout>
              {edit ? (
                <Box ml={2} mt={3}>
                  {renderErrors(formik.errors, errorsArray)}
                </Box>
              ) : null}
              <FormActionButtonLayout>
                <Button
                  variant="contained"
                  disabled={isSubmitEnabled(formik?.errors, formik?.dirty, [
                    "title_property",
                    "category_loc",
                    "category_lvl_1",
                    "fileThumbnail",
                    "otherMedia",
                    "attachments",
                    "info_property",
                    "keywords"
                  ])}
                  onClick={() => setOpenSubmit(true)}
                >
                  {" "}
                  {t("Αποθήκευση και Προεπισκόπηση")}{" "}
                </Button>
                <DialogAction
                  open={openSubmit}
                  handleClose={() => setOpenSubmit(false)}
                  title={t("Αποθήκευση και Προεπισκόπηση Αιτήματος") as string}
                  content={t(
                    "Θέλω να αποθηκεύσω το αίτημα στα πρόχειρα και να δω την προεπισκόπησή του."
                  )}
                  onAccept={() => {
                    setOpenSubmit(false);
                    onSubmit(formik.values, geolocation);
                  }}
                />
                <DialogAction
                  open={openCancel}
                  handleClose={() => setOpenCancel(false)}
                  title={
                    edit
                      ? `${t("Ακύρωση Επεξεργασίας Αιτήματος Τοποθεσίας")}`
                      : `${t("Ακύρωση Δημιουργίας Αιτήματος Τοποθεσίας")}`
                  }
                  content={
                    edit
                      ? t(
                          "Ειστε σιγουρος ότι θέλετε να ακυρώσετε την επεξεργασία αιτήματος;"
                        )
                      : t("Ειστε σιγουρος ότι θέλετε να ακυρώσετε το αίτημα;")
                  }
                  onAccept={() => {
                    setOpenCancel(false);
                    navigate(-1);
                  }}
                />
              </FormActionButtonLayout>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default ApplicationFormSteps;
